import { rem } from "polished";
import React from "react";
import styled from "styled-components";
import Button, { ButtonWrapper } from "../../../../Button";

const ItemDetails = ({ item, onModalClose }) => {
  const {
    label,
    image,
    price,
    unit,
    maxtjocklek,
    mintjocklek,
    width,
    height,
    breadth,
    length,
    skapstorlek,
    content,
    ptype,
  } = item;

  const dimension =
    width && height
      ? [width, height]
      : length && breadth
      ? [length, breadth]
      : [];

  return (
    <Layout className="builder-element">
      <div className="texture-details">
        <div className="detail-header">
          <div className="image">
            <img src={image} alt={label} />
          </div>
          <div className="title">
            <h2>{label}</h2>
            <p >
              <small>Pris:</small>
              <span className="price">
                 {[price, unit].join(" ")}
              </span>
              </p>
          </div>
        </div>

        <div className="information-wrapper">
          {ptype === 'disklador' ? 
            <div dangerouslySetInnerHTML={{ __html: content }} className="information"/> : 
            <>
              <div className="details">
                {dimension && dimension.length ? (
                  <p>
                    Dimensioner:
                    {dimension.join(" X ")} mm
                  </p>
                ) : null}
                {maxtjocklek ? <p>Max tjocklek: {maxtjocklek}</p> : null}
                {mintjocklek ? <p>Min tjocklek: {mintjocklek}</p> : null}
                {skapstorlek ? <p>Skåpstorlek: {skapstorlek} mm</p> : null}
              </div>
          </>}
        </div>

      </div>
    </Layout>
  );
};
export default ItemDetails;

const Layout = styled.div`
  .texture-details {
    padding: ${rem(30)} 0;

    .detail-header {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 30px;
      margin-bottom: ${rem(20)};


      .image {
        flex: 0 0 25%;
        max-width: 25%;

        @media (max-width: 991px) {
         flex: 0 0 50%;
         max-width: 50%;
        }
      }
      .title {
       flex:1;

       h2 {
        font-size: ${rem(24)};
       }
      }

     

      .price {
        color: #b52f40;
        display: block;
      }
    }

    .information-wrapper{
      > h3 {
        margin-bottom: ${rem(15)};
      }
    }

    .information {
      margin: 20px 0;
      h1,h2,h3,h4,h5,h6,img,p {
        margin-top: 20px;
        line-height: normal;
      }

      h1 {
        font-size: 30px;
      }
      h2 {
        font-size: 24px;
      }

      h3 {
        font-size: 22px;
      }

      h4 {
        font-size: 20px;
      }

      h5 {
        font-size: 18px;
      }

      h6{
        font-size: 16px;
      }
      img {
        display: block;
      }
    }

    .image {

    }

    .title {
      margin-bottom: ${rem(10)};
      h2 {
        margin-bottom: 0;
      }
    }

    .details {
      p {
        margin: 0;

        + p {
          margin-top: ${rem(10)};
        }
      }
    }

    .builder-button {
      max-width: 150px;
    }
  }
`;
